"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1260],{

/***/ 89046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgPricingInfoIcon = function SvgPricingInfoIcon(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#333",
        fillRule: "nonzero",
        d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16m.5-3.892c0 .251-.224.454-.5.454s-.5-.203-.5-.454V7.392c0-.251.224-.455.5-.455s.5.204.5.455zm-.469-6.483a.781.781 0 1 1 0-1.562.781.781 0 0 1 0 1.562M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgPricingInfoIcon);


/***/ }),

/***/ 66713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pricing_action_button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var new_button_button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/pricing/pricing-page/contact-us-link-service.js
var contact_us_link_service = __webpack_require__(4442);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./client/services/exceptions-handling-service/exceptions-handling-service.js
var exceptions_handling_service = __webpack_require__(53989);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-action-button/pricing-action-button.scss.js


var StyledPricingSignupButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1oum1930"
})("@media (max-width:", "".concat(vp_sizes/* XXS */.Mp, "px"), '){.pricing-signup-button{input.signup-input[name="email"]{padding:6px;width:100%;margin-left:-10%;}}.try-cta{button.signup-button.ladda-button.xs{padding:8px;margin-bottom:12px;margin-left:-10%;}}}@media (max-width:', vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, '){.pricing-signup-button{input.signup-input[name="email"]{min-width:unset;}}}');
var StyledPricingContactUsButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1oum1931"
})("@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){button.pricing-contact-us-button.xs{padding:8px 32px;}}@media (max-width:", "".concat(vp_sizes/* XXS */.Mp, "px"), "){button.pricing-contact-us-button.xs{padding:12px 16px;margin-bottom:18px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-action-button/default-props.js

/* harmony default export */ var default_props = ({
    userCount: "3",
    signupButtonText: "Try for free",
    contactUsButtonText: "Contact us",
    plan: {
        tier: pricing/* TIERS.BASIC */.Iy.BASIC
    },
    placement: "prices-and-features-card"
});

// EXTERNAL MODULE: ./services/typeform/typeform-service.js
var typeform_service = __webpack_require__(15728);
// EXTERNAL MODULE: ./constants/typeform-contact-sales.js
var typeform_contact_sales = __webpack_require__(13979);
// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-action-button/pricing-action-button.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



















var PricingActionButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PricingActionButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PricingActionButton);
    function PricingActionButton(props) {
        (0,_class_call_check/* default */.Z)(this, PricingActionButton);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onContactUsClicked", function() {
            var _props = _this.props, abTests = _props.abTests, userCount = _props.userCount, plan = _props.plan, placement = _props.placement, isTypeformDisabled = _props.isTypeformDisabled;
            BigBrain("track", bigbrain_event_types.CONTACT_US_BUTTON_CLICKED, {
                placement: placement,
                source: bigbrain_event_types.HP_SOURCE,
                info1: plan.tier,
                info2: userCount
            });
            var shouldShowTypeform = !isTypeformDisabled && (0,monetization_ab_tests_service/* shouldShowTypeformContactUs */.RT)({
                abTests: abTests
            });
            if (shouldShowTypeform) {
                _this.displayTypeform();
            } else {
                _this.redirectToSalesPage();
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "redirectToSalesPage", function() {
            var _props = _this.props, plan = _props.plan, clusterConfig = _props.clusterConfig, abTests = _props.abTests, forcePricing = _props.forcePricing, cookies = _props.cookies;
            window.location = (0,contact_us_link_service/* getPricingContactUsLink */.p)(plan.tier, clusterConfig, abTests, cookies, forcePricing);
        });
        // This is bad copy-paste from use-contact-cales-typeform.js
        // Since it's deprected and will be removed soon, I didn't bother to refactor it
        // The main problem for this copy-paste is the fact that it's class component and no hooks allowed
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "displayTypeform", function() {
            var _props = _this.props, plan = _props.plan, clusterConfig = _props.clusterConfig, abTests = _props.abTests, forcePricing = _props.forcePricing, useNewTypeformUSVariant = _props.useNewTypeformUSVariant, cookies = _props.cookies, forceCurrency = _props.forceCurrency, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, isV13PricingVersion = _props.isV13PricingVersion, testTypeformContactSales = _props.testTypeformContactSales, forceTypeformContactSalesExperience = _props.forceTypeformContactSalesExperience, contactSalesTestMode = _props.contactSalesTestMode;
            var getNewVariantForTest = useNewTypeformUSVariant || (0,acquisition_ab_test_service.shouldUseNewTypeformVariant)(abTests, true);
            var pricingData = {
                forcePricing: forcePricing,
                cookies: cookies,
                abTests: abTests,
                forceCurrency: forceCurrency,
                countryCode: cloudfrontViewerCountry,
                isV13PricingVersion: isV13PricingVersion
            };
            if ((0,typeform_service/* shouldGetTypeformExperience */.ap)({
                abTests: abTests,
                cloudfrontViewerCountry: cloudfrontViewerCountry,
                testTypeformContactSales: testTypeformContactSales,
                forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
                sendBigBrainEvent: true
            })) {
                try {
                    (0,typeform_contact_sales/* openContactSalesTypeform */._X)({
                        country: cloudfrontViewerCountry,
                        deviceType: typeform_contact_sales/* TYPEFORM_DESKTOP_DEVICE_TYPE */.PM,
                        getNewVariantForTest: getNewVariantForTest,
                        isTest: contactSalesTestMode,
                        pricingData: pricingData
                    });
                } catch (e) {
                    var bbEventParams = {
                        name: bigbrain_event_types.TYPEFORM_UNHANDLED_EXCEPTION
                    };
                    (0,exceptions_handling_service/* handleClientException */.N)({
                        e: e,
                        bbEventParams: bbEventParams
                    });
                    window.location = (0,contact_us_link_service/* getPricingContactUsLink */.p)(plan.tier, clusterConfig, abTests, cookies, forcePricing);
                }
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getContactUsButton", function() {
            var contactUsButtonText = _this.props.contactUsButtonText;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPricingContactUsButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                    onClickCallback: _this.onContactUsClicked,
                    disableAnimation: true,
                    size: new_button_button_component.XS,
                    color: "outline-dark-blue-inverted-hover",
                    className: "pricing-contact-us-button",
                    children: contactUsButtonText
                })
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getRegularSignupButton", function() {
            var _props = _this.props, plan = _props.plan, signupButtonText = _props.signupButtonText, userCount = _props.userCount, billingPeriod = _props.billingPeriod;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPricingSignupButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                    parentSegment: pricing/* PLAN_INFO_SEGMENT_NAME */.Us,
                    buttonSize: new_button_button_component.XS,
                    buttonColor: "outline-indigo-inverted-hover",
                    ctaText: signupButtonText,
                    buttonSource: plan.tier,
                    useCtaText: true,
                    className: "pricing-signup-button",
                    pricingDetails: {
                        tier: plan === null || plan === void 0 ? void 0 : plan.tier,
                        userCount: userCount,
                        billingPeriod: billingPeriod
                    },
                    extraData: {
                        pricing_tier: plan === null || plan === void 0 ? void 0 : plan.tier
                    }
                })
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(PricingActionButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, plan = _props.plan, userCount = _props.userCount, clusterConfig = _props.clusterConfig, abTests = _props.abTests, cookies = _props.cookies, forcePricing = _props.forcePricing;
                var tier = plan.tier;
                return (0,pricing_service/* shouldSeeContactUs */.j)(tier, userCount, {
                    clusterConfig: clusterConfig,
                    abTests: abTests,
                    cookies: cookies,
                    forcePricing: forcePricing
                }) ? this.getContactUsButton() : this.getRegularSignupButton();
            }
        }
    ]);
    return PricingActionButton;
}(react.PureComponent);
/* harmony default export */ var pricing_action_button = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(PricingActionButton)));
PricingActionButton.defaultProps = default_props;


/***/ }),

/***/ 44254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ DevIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var DevIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00C875"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.0823 18.6854C20.5179 18.735 18.4564 20.8272 18.4564 23.4035C18.4564 25.9776 20.5142 28.0683 23.0754 28.1215V28.1265H36.7881V28.1226H37.3272V28.1318C37.6002 28.1415 37.8758 28.2482 38.1023 28.4736L40.3903 30.7488C40.8499 31.2059 40.8499 31.9497 40.3903 32.4069L38.1023 34.6821C37.8288 34.9541 37.4838 35.0534 37.1581 35.0175H23.1755C23.1434 35.0175 23.1113 35.0174 23.0793 35.0171L23.0184 35.0174L22.9874 35.0175H22.1198C15.174 34.1911 12.5243 28.596 11.9373 26.2484L11.9138 26.2543C11.6837 25.3422 11.5615 24.3872 11.5615 23.4035C11.5615 17.1265 16.5381 12.0145 22.7619 11.7968C22.8364 11.792 22.9116 11.7896 22.9874 11.7896C23.0195 11.7896 23.0516 11.7897 23.0837 11.7899C23.1142 11.7897 23.1448 11.7896 23.1755 11.7896C23.2504 11.7896 23.3248 11.792 23.3986 11.7967C29.6235 12.0132 34.6014 17.1257 34.6014 23.4035C34.6014 24.3701 34.4833 25.309 34.261 26.2068H26.7847C27.364 25.4231 27.7064 24.4535 27.7064 23.4035C27.7064 20.8277 25.6459 18.7359 23.0823 18.6854ZM10.5349 28.1225H10.1848C8.28079 28.1225 6.7373 29.666 6.7373 31.57C6.7373 33.474 8.28079 35.0175 10.1848 35.0175H16.2326C13.0984 33.1003 11.3599 30.2109 10.5349 28.1225Z",
                fill: "white"
            })
        ]
    });
};


/***/ }),

/***/ 19567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uu": function() { return /* reexport */ AIIcon; },
  "k1": function() { return /* reexport */ AutomationsIcon; },
  "Mz": function() { return /* reexport */ CRMIcon; },
  "Bz": function() { return /* reexport */ DashboardsIcon; },
  "d$": function() { return /* reexport */ dev_icon/* DevIcon */.d; },
  "zv": function() { return /* reexport */ InfrastructureIcon; },
  "wI": function() { return /* reexport */ IntegrationsIcon; },
  "EW": function() { return /* reexport */ MCPIcon; },
  "AP": function() { return /* reexport */ ServiceIcon; },
  "Wd": function() { return /* reexport */ WmIcon; }
});

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dev-icon.js
var dev_icon = __webpack_require__(44254);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/service-icon.js

var ServiceIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#FA4270"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.661 14.8509C13.2565 15.8638 12.084 18.3982 13.1735 20.9858C14.5822 24.3309 20.7807 26.2303 21.0722 26.2728C21.334 26.3133 21.6404 26.1622 21.6404 25.8728C21.6404 25.5834 21.0722 23.1797 21.0722 23.0094C21.0722 22.8392 21.168 22.686 21.3318 22.6179C21.4957 22.5498 28.6837 19.5026 31.0669 18.5003C33.4502 17.4981 34.5801 14.7999 33.5544 12.3655C32.5288 9.93115 29.8157 8.86931 27.4197 9.87795C25.0237 10.8866 18.0655 13.8402 15.661 14.8509Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.3122 33.1464C34.7167 32.1335 35.8892 29.5992 34.7997 27.0116C33.391 23.6665 27.1925 21.7795 26.901 21.7369C26.6392 21.6965 26.3328 21.8476 26.3328 22.1369C26.3328 22.4263 26.901 24.8177 26.901 24.9879C26.901 25.1582 26.8052 25.3114 26.6414 25.3795C26.4775 25.4476 19.2895 28.4948 16.9063 29.497C14.523 30.4993 13.3931 33.1975 14.4188 35.6319C15.4444 38.0684 18.1575 39.1281 20.5535 38.1194C22.9516 37.1108 29.9077 34.1572 32.3122 33.1464Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/crm-icon.js

var CRMIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00D2D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.1191 33.3844C23.4528 32.8913 22.8451 32.3152 22.3121 31.6657C21.0172 30.0879 20.233 28.1619 20.0508 26.1428L30.1529 26.1427C30.6563 26.1424 31.0642 25.7343 31.0642 25.2309C31.0642 23.1705 30.5318 21.1326 29.5028 19.321C28.6751 17.8636 27.5569 16.6074 26.23 15.6224C27.2036 15.3011 28.2443 15.1272 29.3257 15.1272C34.7769 15.1272 39.1959 19.5463 39.1959 24.9975C39.1959 30.4487 34.7769 34.8677 29.3257 34.8677C27.4147 34.8677 25.6305 34.3246 24.1191 33.3844Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.87793 25.2303C8.87793 19.6285 13.4191 15.0874 19.0208 15.0874C20.8485 15.0874 22.5608 15.57 24.0401 16.4142C24.0569 16.4254 24.0741 16.4362 24.0918 16.4463C25.6464 17.3439 26.9437 18.6434 27.8397 20.2208C28.5597 21.4884 28.9928 22.8867 29.122 24.3186H19.0204C18.5168 24.3186 18.1087 24.7268 18.1087 25.2304C18.1087 27.9988 19.0686 30.6817 20.8249 32.8218C21.3919 33.5127 22.0306 34.1332 22.727 34.675C21.5796 35.1256 20.3298 35.3732 19.0208 35.3732C13.4191 35.3732 8.87793 30.8321 8.87793 25.2303Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/wm-icon.js

var WmIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8.08909",
                fill: "#6C6CFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.6134 27.0611C25.382 27.0611 26.8158 25.6274 26.8158 23.8588C26.8158 22.0902 25.382 20.6565 23.6134 20.6565C21.8449 20.6565 20.4111 22.0902 20.4111 23.8588C20.4111 25.6274 21.8449 27.0611 23.6134 27.0611Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.6134 16.078C25.382 16.078 26.8158 14.6442 26.8158 12.8757C26.8158 11.1071 25.382 9.67334 23.6134 9.67334C21.8449 9.67334 20.4111 11.1071 20.4111 12.8757C20.4111 14.6442 21.8449 16.078 23.6134 16.078Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1652 23.669C14.9338 23.669 16.3675 22.2353 16.3675 20.4667C16.3675 18.6981 14.9338 17.2644 13.1652 17.2644C11.3966 17.2644 9.96289 18.6981 9.96289 20.4667C9.96289 22.2353 11.3966 23.669 13.1652 23.669Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.1545 35.9488C18.9231 35.9488 20.3568 34.5151 20.3568 32.7465C20.3568 30.9779 18.9231 29.5442 17.1545 29.5442C15.3859 29.5442 13.9521 30.9779 13.9521 32.7465C13.9521 34.5151 15.3859 35.9488 17.1545 35.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.0656 35.9488C31.8342 35.9488 33.2679 34.5151 33.2679 32.7465C33.2679 30.9779 31.8342 29.5442 30.0656 29.5442C28.297 29.5442 26.8633 30.9779 26.8633 32.7465C26.8633 34.5151 28.297 35.9488 30.0656 35.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0597 23.669C35.8283 23.669 37.2621 22.2353 37.2621 20.4667C37.2621 18.6981 35.8283 17.2644 34.0597 17.2644C32.2911 17.2644 30.8574 18.6981 30.8574 20.4667C30.8574 22.2353 32.2911 23.669 34.0597 23.669Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/ai-icon.js

var AIIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_589_3088",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.7196 3.83214L17.0691 4.2596C17.1738 4.29261 17.2451 4.38989 17.2451 4.49985C17.2451 4.60981 17.1738 4.7068 17.0691 4.74011L15.7196 5.16786C15.5737 5.21414 15.4594 5.32852 15.4131 5.47444L14.9854 6.82401C14.9523 6.92866 14.8551 7 14.7451 7C14.6352 7 14.5382 6.92866 14.5049 6.82401L14.0772 5.47444C14.0309 5.32852 13.9165 5.21414 13.7706 5.16786L12.4211 4.74011C12.3165 4.70709 12.2451 4.60952 12.2451 4.49985C12.2451 4.39019 12.3165 4.29291 12.4211 4.2596L13.7706 3.83214C13.9165 3.78586 14.0309 3.67148 14.0772 3.52556L14.5049 2.17599C14.5379 2.07134 14.6352 2 14.7451 2C14.8551 2 14.952 2.07134 14.9854 2.17599L15.4131 3.52556C15.4594 3.67148 15.5737 3.78586 15.7196 3.83214ZM11.4327 10.0881L14.8032 11.1557C15.0645 11.2381 15.2427 11.4811 15.2427 11.7557C15.2427 12.0304 15.0645 12.2726 14.8032 12.3558L11.4327 13.4241C11.0683 13.5397 10.7827 13.8254 10.6671 14.1898L9.5988 17.5605C9.51635 17.8218 9.27339 18 8.99878 18C8.72417 18 8.48196 17.8218 8.39877 17.5605L7.33051 14.1898C7.21492 13.8254 6.92926 13.5397 6.56483 13.4241L3.19441 12.3558C2.93305 12.2733 2.75488 12.0296 2.75488 11.7557C2.75488 11.4818 2.93305 11.2389 3.19441 11.1557L6.56483 10.0881C6.92926 9.97251 7.21492 9.68683 7.33051 9.32238L8.39877 5.95176C8.48122 5.69038 8.72417 5.51221 8.99878 5.51221C9.27339 5.51221 9.51561 5.69038 9.5988 5.95176L10.6671 9.32238C10.7827 9.68683 11.0683 9.97251 11.4327 10.0881Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0691 4.2596L16.6917 5.45125L16.693 5.45167L17.0691 4.2596ZM15.7196 3.83214L15.3417 5.02364L15.3422 5.02379L15.7196 3.83214ZM17.0691 4.74011L17.4468 5.93168L17.4483 5.93122L17.0691 4.74011ZM15.7196 5.16786L15.342 3.97628L15.3417 3.97636L15.7196 5.16786ZM15.4131 5.47444L14.2216 5.09655L14.2215 5.09679L15.4131 5.47444ZM14.9854 6.82401L13.7938 6.44635L13.7933 6.44794L14.9854 6.82401ZM14.5049 6.82401L13.3133 7.20166L13.3138 7.20312L14.5049 6.82401ZM14.0772 5.47444L15.2687 5.09679L15.2687 5.09654L14.0772 5.47444ZM13.7706 5.16786L14.1485 3.97636L14.1483 3.97628L13.7706 5.16786ZM12.4211 4.74011L12.7988 3.54853L12.7972 3.54804L12.4211 4.74011ZM12.4211 4.2596L12.0436 3.06795L12.0419 3.06849L12.4211 4.2596ZM13.7706 3.83214L14.148 5.02379L14.1485 5.02364L13.7706 3.83214ZM14.0772 3.52556L15.2687 3.90346L15.2687 3.90321L14.0772 3.52556ZM14.5049 2.17599L15.6965 2.55364L15.697 2.55206L14.5049 2.17599ZM14.9854 2.17599L16.1769 1.79834L16.1765 1.79687L14.9854 2.17599ZM15.4131 3.52556L14.2215 3.90321L14.2216 3.90345L15.4131 3.52556ZM14.8032 11.1557L14.4257 12.3473L14.4271 12.3478L14.8032 11.1557ZM11.4327 10.0881L11.0548 11.2796L11.0553 11.2797L11.4327 10.0881ZM14.8032 12.3558L15.1809 13.5474L15.1823 13.5469L14.8032 12.3558ZM11.4327 13.4241L11.055 12.2325L11.0548 12.2326L11.4327 13.4241ZM10.6671 14.1898L9.47555 13.8119L9.47548 13.8122L10.6671 14.1898ZM9.5988 17.5605L8.40722 17.1828L8.40672 17.1844L9.5988 17.5605ZM8.39877 17.5605L7.20718 17.9381L7.20765 17.9396L8.39877 17.5605ZM7.33051 14.1898L8.52209 13.8122L8.52202 13.8119L7.33051 14.1898ZM6.56483 13.4241L6.94277 12.2326L6.94253 12.2325L6.56483 13.4241ZM3.19441 12.3558L3.5721 11.1642L3.57052 11.1637L3.19441 12.3558ZM3.19441 11.1557L2.81695 9.96403L2.81524 9.96458L3.19441 11.1557ZM6.56483 10.0881L6.94229 11.2797L6.94277 11.2796L6.56483 10.0881ZM7.33051 9.32238L8.52202 9.70027L8.52209 9.70003L7.33051 9.32238ZM8.39877 5.95176L9.59035 6.32941L9.59085 6.32783L8.39877 5.95176ZM9.5988 5.95176L10.7904 5.57411L10.7899 5.57263L9.5988 5.95176ZM10.6671 9.32238L9.47548 9.70003L9.47555 9.70027L10.6671 9.32238ZM17.4466 3.06795L16.0971 2.6405L15.3422 5.02379L16.6917 5.45124L17.4466 3.06795ZM18.4951 4.49985C18.4951 3.84494 18.0706 3.26482 17.4453 3.06752L16.693 5.45167C16.277 5.3204 15.9951 4.93484 15.9951 4.49985H18.4951ZM17.4483 5.93122C18.0687 5.73371 18.4951 5.15708 18.4951 4.49985H15.9951C15.9951 4.06254 16.2788 3.67988 16.69 3.549L17.4483 5.93122ZM16.0973 6.35943L17.4468 5.93168L16.6914 3.54854L15.342 3.97628L16.0973 6.35943ZM16.6046 5.85233C16.528 6.09371 16.339 6.28278 16.0976 6.35935L15.3417 3.97636C14.8085 4.1455 14.3907 4.56333 14.2216 5.09655L16.6046 5.85233ZM16.1769 7.20166L16.6047 5.85209L14.2215 5.09679L13.7938 6.44636L16.1769 7.20166ZM14.7451 8.25C15.4001 8.25 15.9802 7.82535 16.1774 7.20007L13.7933 6.44794C13.9245 6.03197 14.31 5.75 14.7451 5.75V8.25ZM13.3138 7.20312C13.5112 7.82349 14.0878 8.25 14.7451 8.25V5.75C15.1826 5.75 15.5652 6.03383 15.696 6.44489L13.3138 7.20312ZM12.8856 5.85209L13.3133 7.20166L15.6965 6.44636L15.2687 5.09679L12.8856 5.85209ZM13.3927 6.35935C13.1512 6.28278 12.9622 6.09371 12.8856 5.85234L15.2687 5.09654C15.0996 4.56333 14.6818 4.1455 14.1485 3.97636L13.3927 6.35935ZM12.0434 5.93168L13.3929 6.35943L14.1483 3.97628L12.7988 3.54854L12.0434 5.93168ZM10.9951 4.49985C10.9951 5.15361 11.4188 5.73463 12.045 5.93218L12.7972 3.54804C13.2141 3.67956 13.4951 4.06542 13.4951 4.49985H10.9951ZM12.0419 3.06849C11.4207 3.26625 10.9951 3.84377 10.9951 4.49985H13.4951C13.4951 4.93661 13.2122 5.31956 12.8003 5.4507L12.0419 3.06849ZM13.3931 2.6405L12.0436 3.06795L12.7986 5.45124L14.148 5.02379L13.3931 2.6405ZM12.8856 3.14766C12.9622 2.90629 13.1512 2.71722 13.3927 2.64065L14.1485 5.02364C14.6818 4.8545 15.0996 4.43667 15.2687 3.90346L12.8856 3.14766ZM13.3133 1.79834L12.8856 3.14791L15.2687 3.90321L15.6965 2.55364L13.3133 1.79834ZM14.7451 0.75C14.0901 0.75 13.51 1.17467 13.3128 1.79993L15.697 2.55206C15.5657 2.96801 15.1802 3.25 14.7451 3.25V0.75ZM16.1765 1.79687C15.979 1.17649 15.4024 0.75 14.7451 0.75V3.25C14.3077 3.25 13.9251 2.96619 13.7942 2.55512L16.1765 1.79687ZM16.6047 3.14791L16.1769 1.79834L13.7938 2.55364L14.2215 3.90321L16.6047 3.14791ZM16.0976 2.64065C16.339 2.71722 16.528 2.90629 16.6046 3.14767L14.2216 3.90345C14.3907 4.43667 14.8085 4.8545 15.3417 5.02364L16.0976 2.64065ZM15.1806 9.96404L11.8102 8.89645L11.0553 11.2797L14.4257 12.3473L15.1806 9.96404ZM16.4927 11.7557C16.4927 10.9362 15.9613 10.2104 15.1793 9.96361L14.4271 12.3478C14.1677 12.2659 13.9927 12.0261 13.9927 11.7557H16.4927ZM15.1823 13.5469C15.9595 13.2995 16.4927 12.5776 16.4927 11.7557H13.9927C13.9927 11.4831 14.1696 11.2457 14.424 11.1647L15.1823 13.5469ZM11.8104 14.6157L15.1809 13.5474L14.4255 11.1642L11.055 12.2325L11.8104 14.6157ZM11.8586 14.5677C11.8513 14.5906 11.8336 14.6084 11.8107 14.6156L11.0548 12.2326C10.303 12.4711 9.71397 13.0602 9.47555 13.8119L11.8586 14.5677ZM10.7904 17.9381L11.8587 14.5675L9.47548 13.8122L8.40722 17.1828L10.7904 17.9381ZM8.99878 19.25C9.81845 19.25 10.5442 18.7185 10.7909 17.9365L8.40672 17.1844C8.4885 16.9251 8.72834 16.75 8.99878 16.75V19.25ZM7.20765 17.9396C7.45499 18.7167 8.17677 19.25 8.99878 19.25V16.75C9.27157 16.75 9.50893 16.927 9.58989 17.1813L7.20765 17.9396ZM6.13892 14.5675L7.20718 17.9381L9.59035 17.1828L8.52209 13.8122L6.13892 14.5675ZM6.1869 14.6156C6.164 14.6084 6.14624 14.5906 6.139 14.5677L8.52202 13.8119C8.2836 13.0602 7.69452 12.4711 6.94277 12.2326L6.1869 14.6156ZM2.81671 13.5474L6.18714 14.6157L6.94253 12.2325L3.5721 11.1642L2.81671 13.5474ZM1.50488 11.7557C1.50488 12.5737 2.03544 13.3009 2.81829 13.5479L3.57052 11.1637C3.83065 11.2458 4.00488 11.4855 4.00488 11.7557H1.50488ZM2.81524 9.96458C2.03728 10.2122 1.50488 10.9354 1.50488 11.7557H4.00488C4.00488 12.0283 3.82881 12.2655 3.57357 12.3468L2.81524 9.96458ZM6.18738 8.89645L2.81695 9.96404L3.57186 12.3473L6.94229 11.2797L6.18738 8.89645ZM6.139 8.94449C6.14624 8.92165 6.164 8.90386 6.1869 8.8966L6.94277 11.2796C7.69452 11.0411 8.2836 10.452 8.52202 9.70027L6.139 8.94449ZM7.20718 5.57411L6.13892 8.94473L8.52209 9.70003L9.59035 6.32941L7.20718 5.57411ZM8.99878 4.26221C8.17909 4.26221 7.45337 4.79372 7.20668 5.57568L9.59085 6.32783C9.50908 6.58705 9.26925 6.76221 8.99878 6.76221V4.26221ZM10.7899 5.57263C10.5426 4.79553 9.82077 4.26221 8.99878 4.26221V6.76221C8.72602 6.76221 8.48864 6.58523 8.40769 6.33088L10.7899 5.57263ZM11.8587 8.94473L10.7904 5.57411L8.40722 6.32941L9.47548 9.70003L11.8587 8.94473ZM11.8107 8.8966C11.8336 8.90386 11.8513 8.92165 11.8586 8.94449L9.47555 9.70027C9.71397 10.452 10.303 11.0411 11.0548 11.2796L11.8107 8.8966Z",
                fill: color || "#676879",
                mask: "url(#path-1-inside-1_589_3088)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dashboards-icon.js

var DashboardsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.32292",
                y: "3.23966",
                width: "15.3542",
                height: "13.5208",
                rx: "1.26042",
                stroke: color || "#676879",
                strokeWidth: "1.14583"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "1.75",
                y1: "6.67708",
                x2: "18.25",
                y2: "6.67708",
                stroke: color || "#676879",
                strokeWidth: "1.14583"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2399 10C14.2399 9.68359 13.9834 9.42708 13.667 9.42708C13.3506 9.42708 13.0941 9.68359 13.0941 10L14.2399 10ZM13.0941 10L13.0941 16.4167L14.2399 16.4167L14.2399 10L13.0941 10Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5729 10.9167C10.5729 10.6003 10.3164 10.3438 10 10.3438C9.68359 10.3438 9.42708 10.6003 9.42708 10.9167L10.5729 10.9167ZM9.42708 10.9167L9.42708 16.4167L10.5729 16.4167L10.5729 10.9167L9.42708 10.9167Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.90592 12.75C6.90592 12.4336 6.64942 12.1771 6.33301 12.1771C6.01659 12.1771 5.76009 12.4336 5.76009 12.75L6.90592 12.75ZM5.76009 12.75L5.76009 16.4167L6.90592 16.4167L6.90592 12.75L5.76009 12.75Z",
                fill: color || "#676879"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/automations-icon.js

var AutomationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4.3329",
                y: "6.55556",
                width: "11.3333",
                height: "9.55556",
                rx: "1.22222",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.333 9.55542H16.2219C17.2037 9.55542 17.9997 10.3514 17.9997 11.3332V12.2221C17.9997 13.2039 17.2037 13.9999 16.2219 13.9999H15.333",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.66699 9.55542H3.7781C2.79626 9.55542 2.00032 10.3514 2.00032 11.3332V12.2221C2.00032 13.2039 2.79626 13.9999 3.7781 13.9999H4.66699",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.2227 10.4443L12.2227 11.7777",
                stroke: color || "#676879",
                strokeWidth: "1.11111",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.77734 10.4443L7.77734 11.7777",
                stroke: color || "#676879",
                strokeWidth: "1.11111",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5556 3.33325C10.5556 3.02643 10.3068 2.7777 10 2.7777C9.69318 2.7777 9.44444 3.02643 9.44444 3.33325L10.5556 3.33325ZM9.44444 3.33325L9.44444 6.88881L10.5556 6.88881L10.5556 3.33325L9.44444 3.33325Z",
                fill: color || "#676879"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/infrastructure-icon.js

var InfrastructureIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 6.25007C3.75 6.91313 4.4085 7.54904 5.58064 8.01789C6.75277 8.48675 8.34253 8.75015 10.0002 8.75015C11.6578 8.75015 13.2476 8.48675 14.4197 8.01789C15.5919 7.54904 16.2504 6.91313 16.2504 6.25007C16.2504 5.58701 15.5919 4.95111 14.4197 4.48225C13.2476 4.0134 11.6578 3.75 10.0002 3.75C8.34253 3.75 6.75277 4.0134 5.58064 4.48225C4.4085 4.95111 3.75 5.58701 3.75 6.25007Z",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 6.25V9.99955C3.75 11.3802 6.54842 12.4996 10.0002 12.4996C13.452 12.4996 16.2504 11.3807 16.2504 9.99955V6.25",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 9.99951V13.7496C3.75 15.1302 6.54842 16.2497 10.0002 16.2497C13.452 16.2497 16.2504 15.1302 16.2504 13.7496V9.99951",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/integrations-icon.js

var IntegrationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_589_3100)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.84863 12.293L8.18694 16.5269C8.84001 17.1643 9.88612 17.1516 10.5235 16.4985L13.2608 13.6938L15.9981 10.889C16.6355 10.2359 16.6227 9.18982 15.9697 8.55246L11.6314 4.31848",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.65137 13.5205L12.8288 3.09233",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.5918 2.11961C6.34477 1.87852 5.94908 1.88333 5.70799 2.13036C5.4669 2.37739 5.47171 2.77309 5.71874 3.01418L6.5918 2.11961ZM5.71874 3.01418L9.39928 6.60621L10.2723 5.71163L6.5918 2.11961L5.71874 3.01418Z",
                        fill: color || "#676879"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.9609 14.0007L16.6415 17.5928",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.40137 6.41404C2.15434 6.17295 1.75865 6.17777 1.51756 6.4248C1.27647 6.67183 1.28128 7.06753 1.52831 7.30862L2.40137 6.41404ZM1.52831 7.30862L5.20885 10.9006L6.08191 10.0061L2.40137 6.41404L1.52831 7.30862Z",
                        fill: color || "#676879"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_589_3100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/mcp-icon.js


var MCPIcon = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_792_2516)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.6763 3.01819C11.9491 2.30546 10.7854 2.30546 10.0582 3.01819L3.0618 9.88364C2.81453 10.1164 2.43635 10.1164 2.18907 9.88364C1.95635 9.65091 1.9418 9.27273 2.18907 9.04L9.18544 2.16C10.4073 0.981822 12.3418 0.981822 13.5636 2.16C14.2473 2.82909 14.5818 3.78909 14.4363 4.73455C15.3963 4.60364 16.3709 4.90909 17.0545 5.59273L17.0836 5.63637C18.2618 6.78546 18.2909 8.67637 17.1418 9.86909C17.1273 9.88364 17.0982 9.91273 17.0836 9.92728L10.7563 16.1382C10.6836 16.2109 10.6691 16.3418 10.7563 16.4145L12.0509 17.6945C12.2836 17.9273 12.2982 18.3055 12.0509 18.5382C11.8036 18.7709 11.4254 18.7709 11.1782 18.5382L9.88362 17.2582C9.33089 16.72 9.31635 15.8327 9.85453 15.28C9.85453 15.28 9.86907 15.2655 9.88362 15.2509L16.2109 9.04C16.9236 8.34182 16.9382 7.20728 16.24 6.49455L16.2109 6.46546L16.1818 6.43637C15.4545 5.72364 14.2909 5.72364 13.5636 6.43637L8.3418 11.5564L8.26907 11.6291C8.0218 11.8618 7.64362 11.8618 7.39635 11.6291C7.16362 11.3964 7.14908 11.0182 7.39635 10.7855L12.6909 5.59273C13.4036 4.89455 13.4182 3.76 12.72 3.04728C12.72 3.04728 12.7054 3.03273 12.6909 3.01819H12.6763Z",
                        fill: "#676879"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.8036 4.73449C12.0363 4.50176 12.0509 4.12358 11.8036 3.89085C11.5563 3.65813 11.1782 3.65813 10.9309 3.89085L5.75271 8.96722C4.57453 10.1163 4.54544 12.0072 5.69453 13.1999C5.70907 13.2145 5.73817 13.2436 5.75271 13.2581C6.97453 14.4363 8.90907 14.4363 10.1309 13.2581L15.3091 8.18176C15.5418 7.94904 15.5563 7.57085 15.3091 7.33813C15.0618 7.1054 14.6836 7.1054 14.4363 7.33813L9.25817 12.4145C8.53089 13.1272 7.36726 13.1272 6.63998 12.4145C5.92726 11.7163 5.91271 10.5818 6.61089 9.86904L6.63998 9.83994L11.8182 4.76358L11.8036 4.73449Z",
                        fill: "#676879"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_792_2516",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "17.4545",
                        fill: "white",
                        transform: "translate(2 1.27271)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/index.js












/***/ }),

/***/ 68988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ ProductIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/marketing-icon.js

var MarketingIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "108",
        height: "77",
        viewBox: "0 0 108 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.8846 31.8694V74.0978C40.8846 75.3963 41.9317 76.449 43.2234 76.449H64.6875C65.9792 76.449 67.0263 75.3963 67.0263 74.0978V35.6944C67.0263 31.6893 70.2579 28.4425 74.2442 28.4425C78.2306 28.4425 81.4622 31.6893 81.4622 35.6944V74.0978C81.4622 75.3963 82.5093 76.449 83.8009 76.449H105.265C106.557 76.449 107.604 75.3963 107.604 74.0978V31.8694C107.604 14.2684 92.6684 0 74.2443 0C55.8203 0 40.8846 14.2684 40.8846 31.8694Z",
                fill: "#CA0C6B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.307129 31.8694V74.0978C0.307129 75.3963 1.35423 76.449 2.64591 76.449H24.11C25.4017 76.449 26.4488 75.3963 26.4488 74.0978V35.6944C26.4488 31.6893 29.6804 28.4425 33.6667 28.4425C37.6531 28.4425 40.8847 31.6893 40.8847 35.6944V74.0978C40.8847 75.3963 41.9318 76.449 43.2234 76.449H64.6877C65.9794 76.449 67.0265 75.3963 67.0265 74.0978V31.8694C67.0265 14.2684 52.0909 0 33.6668 0C15.2428 0 0.307129 14.2684 0.307129 31.8694Z",
                fill: "url(#paint0_linear_2481_123944-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.307129 51.8892H26.4453V74.1224C26.4453 75.4071 25.4086 76.4487 24.1299 76.4487H2.62255C1.34378 76.4487 0.307129 75.4071 0.307129 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.8883 51.8892H67.0265V74.1224C67.0265 75.4071 65.9898 76.4487 64.711 76.4487H43.2037C41.925 76.4487 40.8883 75.4071 40.8883 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M81.469 51.8892H107.607V74.1224C107.607 75.4071 106.571 76.4487 105.292 76.4487H83.7844C82.5057 76.4487 81.469 75.4071 81.469 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2481_123944-".concat(id),
                    x1: "-1.86843",
                    y1: "71.0347",
                    x2: "106.667",
                    y2: "57.1665",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#FF158A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.765625",
                            stopColor: "#FF158A",
                            stopOpacity: "0.5"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/software-icon.js

var SoftwareIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "119",
        height: "90",
        viewBox: "0 0 119 90",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "119",
                height: "90",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M46.3084 16.662C46.3084 10.2213 51.5296 5 57.9704 5C79.6724 5 97.2578 22.5854 97.2578 44.2874C97.2578 65.9895 79.6724 83.5748 57.9704 83.5748H14.662C8.22126 83.5748 3 78.3536 3 71.9128C3 65.4721 8.22126 60.2508 14.662 60.2508H57.9704C66.7909 60.2508 73.9338 53.108 73.9338 44.2874C73.9338 35.4669 66.7909 28.324 57.9704 28.324C51.5296 28.324 46.3084 23.1028 46.3084 16.662Z",
                fill: "url(#paint0_linear_2426_1297)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M19.3438 44.2874C19.3438 22.5854 36.9291 5 58.6312 5C65.0719 5 70.2932 10.2213 70.2932 16.662C70.2932 23.1028 65.0719 28.324 58.6312 28.324C49.8106 28.324 42.6678 35.4669 42.6678 44.2874C42.6678 53.108 49.8106 60.2508 58.6312 60.2508H106.503V83.5748H58.6312C36.9291 83.5748 19.3438 65.9895 19.3438 44.2874Z",
                fill: "#00CA72"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.834 69.1374C118.389 70.6837 118.389 73.1999 116.834 74.7462L109.094 82.4428C106.6 84.9237 102.35 83.1567 102.35 79.6384L102.35 64.2452C102.35 60.7269 106.6 58.9599 109.094 61.4408L116.834 69.1374Z",
                fill: "#00CA72"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2426_1297",
                    x1: "74.4638",
                    y1: "31.3159",
                    x2: "67.4632",
                    y2: "63.8687",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            "stop-color": "#00CA72"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.905957",
                            "stop-color": "#00CA72",
                            "stop-opacity": "0.6"
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dev-icon.js
var dev_icon = __webpack_require__(44254);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/index.js + 9 modules
var icons = __webpack_require__(19567);
;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/project-management-icon.js

var ProjectManagementIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "108",
        height: "105",
        viewBox: "0 0 108 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.066 18.5174C27.066 16.0799 28.3867 13.8276 30.5307 12.6089L50.4255 1.29956C52.5695 0.0808159 55.2109 0.0808198 57.3549 1.29956L77.2498 12.6089C79.3937 13.8276 80.7145 16.0799 80.7145 18.5174L80.7156 45.0751L53.8913 60.3235C44.95 55.2407 36.0086 50.158 27.0671 45.0752C27.0671 36.2226 27.066 27.3702 27.066 18.5174Z",
                fill: "url(#paint0_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.0666 45.076C19.2958 49.5186 11.4929 53.9141 3.7059 58.3407C1.56195 59.5595 0.241213 61.8118 0.24121 64.2493L0.241212 86.8679C0.241212 89.3053 1.56194 91.5577 3.7059 92.7764L23.6007 104.086C25.7447 105.304 28.3862 105.304 30.5301 104.086L53.8908 90.821L53.8908 60.3243C44.9473 55.2404 36.007 50.1582 27.0666 45.076Z",
                fill: "url(#paint1_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M104.073 58.3406C106.217 59.5594 107.538 61.8117 107.538 64.2492L107.538 86.8678C107.538 89.3053 106.217 91.5576 104.073 92.7763L84.1785 104.086C82.0346 105.304 79.3931 105.304 77.2491 104.086L53.8891 90.8212L53.8891 60.3245C62.8305 55.2418 71.7719 50.1589 80.7133 45.0762C88.4865 49.5201 96.289 53.9156 104.073 58.3406Z",
                fill: "url(#paint2_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                styles: "mix-blend-mode:multiply",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M27.066 47.0451C27.066 45.8264 27.7264 44.7002 28.7984 44.0908L52.1579 30.812C53.2299 30.2026 54.5506 30.2026 55.6226 30.812L78.9822 44.0908C80.0541 44.7002 80.7145 45.8263 80.7145 47.0451L80.7145 73.6027C80.7145 74.8215 80.0541 75.9476 78.9822 76.557L55.6226 89.8358C54.5507 90.4452 53.2299 90.4452 52.1579 89.8358L28.7984 76.557C27.7264 75.9476 27.0661 74.8215 27.0661 73.6027L27.066 47.0451Z",
                    fill: "url(#paint3_linear_2481_124011-".concat(id, ")")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2481_124011-".concat(id),
                        x1: "27.0659",
                        y1: "14.6157",
                        x2: "80.2724",
                        y2: "45.841",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_2481_124011-".concat(id),
                        x1: "53.8897",
                        y1: "60.2978",
                        x2: "0.683283",
                        y2: "91.523",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_2481_124011-".concat(id),
                        x1: "53.8897",
                        y1: "60.2976",
                        x2: "107.096",
                        y2: "91.5224",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_2481_124011-".concat(id),
                        x1: "53.8903",
                        y1: "30.355",
                        x2: "53.8903",
                        y2: "90.2929",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FDAB3D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00",
                                stopOpacity: "0.51"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/email-campaigns-icon.js

var emailCampaignsIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "80",
                height: "80",
                rx: "9",
                fill: "#00D2D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.5498 38.3041H27.2893C26.3449 38.3041 25.5793 39.0697 25.5793 40.014C25.5793 40.9584 26.3449 41.7239 27.2893 41.7239H45.6335L40.2312 61.8854H36.8854C24.7984 61.8854 15 52.087 15 40C15 27.913 24.7984 18.1146 36.8854 18.1146H51.9596L46.5498 38.3041Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.2716 61.8854H44.0044L49.4067 41.7239C54.0824 41.7239 57.4855 46.159 56.2754 50.6754L53.2716 61.8854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.9888 29.3526C60.574 34.6326 55.7893 38.3041 50.323 38.3041L55.7328 18.1146H65L61.9888 29.3526Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/product-icon.js








var productNameToIconMap = {
    core: icons/* WmIcon */.Wd,
    projectManagement: ProjectManagementIcon,
    software: SoftwareIcon,
    marketing: MarketingIcon,
    crm: icons/* CRMIcon */.Mz,
    service: icons/* ServiceIcon */.AP,
    serviceWhite: icons/* ServiceIcon */.AP,
    coreWhite: icons/* WmIcon */.Wd,
    softwareWhite: dev_icon/* DevIcon */.d,
    crmWhite: icons/* CRMIcon */.Mz,
    marketingCampaigns: emailCampaignsIcon
};
var ProductIcon = function(param) {
    var product = param.product;
    var IconComponent = productNameToIconMap[product];
    return IconComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {
        id: (0,v4/* default */.Z)()
    }) : null;
};


/***/ }),

/***/ 97169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uI": function() { return /* binding */ getPlanFeatures; },
  "Yi": function() { return /* binding */ getPlanValueFeatures; },
  "nO": function() { return /* binding */ translateProductKeyFallbackToCore; }
});

// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/default_sections.js
var default_sections = __webpack_require__(16168);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/index.js

var getDefaultPricingPageSections = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return (0,default_sections/* getDefaultSections */.VG)({
        cookies: cookies,
        abTests: abTests,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
};

// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/free_tier_essentials.js
var free_tier_essentials = __webpack_require__(8876);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/value-features/index.js
var value_features = __webpack_require__(69078);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./services/pricing-features-service.js








var getPlanValueFeatures = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, clusterId = param.clusterId, clusterConfig = param.clusterConfig, forcePricing = param.forcePricing;
    if (clusterId) {
        var _clusterConfig_payments_view;
        var pricingPageConfig = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : _clusterConfig_payments_view.pricing;
        var valueFeatures = (0,clusterized_pricing_page_service/* getValueFeaturesFromClusterConfig */.A2)(pricingPageConfig === null || pricingPageConfig === void 0 ? void 0 : pricingPageConfig.value_features, {
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier,
            abTests: abTests,
            cookies: cookies
        });
        if (valueFeatures && (0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
            abTests: abTests,
            cookies: cookies,
            forcePricing: forcePricing
        })) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED, {
                kind: "user_experience_for_cluster",
                info1: clusterId,
                info2: "payments_view[pricing]",
                data: pricingPageConfig,
                placement: "value_features"
            });
            return valueFeatures;
        }
    }
    // otherwise, returning default values
    return (0,value_features/* getDefaultValueFeatures */.v)({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
};
var getPlanFeatures = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, clusterId = param.clusterId, clusterConfig = param.clusterConfig, forcePricing = param.forcePricing;
    if (clusterId) {
        var _clusterConfig_payments_view;
        var pricingPageConfig = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : _clusterConfig_payments_view.pricing;
        var pricingPageSections = (0,clusterized_pricing_page_service/* getPricingPageSectionsFromClusterConfig */.LF)(pricingPageConfig, {
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
        if (pricingPageSections && (0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
            abTests: abTests,
            cookies: cookies,
            forcePricing: forcePricing
        })) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED, {
                kind: "user_experience_for_cluster",
                info1: clusterId,
                info2: "payments_view[pricing]",
                data: pricingPageConfig,
                placement: "pricing_features"
            });
            return pricingPageSections; // successfully retrieved from cluster config.
        }
    }
    // otherwise - no cluster ID, or user wasn't in cluster test -
    // using default sections list, but possibly modifying it to use the free tier essentials:
    var sections = getDefaultPricingPageSections({
        cookies: cookies,
        abTests: abTests,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
    if (hasFreeTier) {
        // pricing pages with free tier have a different essentials list - depending on the free tier version
        var freeTierEssentials = (0,free_tier_essentials/* getFreeTierEssentials */.b)(abTests, cookies);
        sections.splice(0, 1, freeTierEssentials); // inserting the free tier essentials instead of the regular essentials
    }
    return sections;
};
var translateProductKeyFallbackToCore = function(param) {
    var productName = param.productName, key = param.key;
    var translate = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z).translate;
    var name = translate("pricingPage.products.".concat(productName, ".featuresList.").concat(key));
    if (name.startsWith("pricingPage.products")) {
        return translate("pricingPage.products.core.featuresList.".concat(key));
    }
    return name;
};


/***/ }),

/***/ 56492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OU": function() { return /* binding */ getTierTranslationKey; },
/* harmony export */   "f_": function() { return /* binding */ TIERS_COLORS_MAP; },
/* harmony export */   "kP": function() { return /* binding */ getPlanColor; },
/* harmony export */   "qD": function() { return /* binding */ getPreviousTierNameByTier; },
/* harmony export */   "qY": function() { return /* binding */ getPlans; },
/* harmony export */   "wD": function() { return /* binding */ getPreviousTierName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12573);
/* harmony import */ var _pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69017);
/* harmony import */ var _bigbrain_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95470);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);
/* harmony import */ var _pricing_page_clusterization_clusterized_pricing_page_helper_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85920);
/* harmony import */ var _ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46724);









var _obj;
var TIERS_COLORS_MAP = (_obj = {}, // in here, 'tierGeneralColor' is the general indicator of the tier (found at the top of the tier cards),
// 'tierContentColor' should be the color used for displaying content colored with that tier's color, e.g. texts,
// which require better accessibility and contrast.
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].mud */ .Z.mud,
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].mud */ .Z.mud
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["purple-v2"] */ .Z["purple-v2"],
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["purple-v2"] */ .Z["purple-v2"]
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].blue */ .Z.blue,
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].blue */ .Z.blue
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["done-green"] */ .Z["done-green"],
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["accessible-green"] */ .Z["accessible-green"]
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["brand-enterprise-dark"] */ .Z["brand-enterprise-dark"],
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["brand-enterprise-dark"] */ .Z["brand-enterprise-dark"]
}), _obj);
var getPlanColor = function(plan) {
    var isContentColored = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var colorProperty = isContentColored ? "tierContentColor" : "tierGeneralColor";
    return TIERS_COLORS_MAP[plan.tier][colorProperty];
};
var getDefaultPlans = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var basicPlan = {
        displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC),
        tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC
    };
    var plans = [
        {
            displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD),
            tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD
        },
        {
            displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO),
            tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO
        },
        {
            displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE),
            tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE
        }
    ];
    var hideBasic = (0,_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_6__/* .shouldHideBasic */ .gd)({
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing,
        hasStudentPlan: hasStudentPlan
    });
    if (!hideBasic) {
        plans.unshift(basicPlan);
    }
    if (hasFreeTier || hasStudentPlan) {
        plans.unshift({
            displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, {
                hasStudentPlan: hasStudentPlan
            }),
            tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE
        });
    }
    return plans;
};
var getPlans = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _clusterConfig_payments_view;
    var hasFreeTier = options.hasFreeTier, hasStudentPlan = options.hasStudentPlan, clusterConfig = options.clusterConfig, clusterId = options.clusterId, abTests = options.abTests, cookies = options.cookies, forcePricing = options.forcePricing;
    var plans = getDefaultPlans({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        forcePricing: forcePricing,
        cookies: cookies
    });
    var pricingPageConfig = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : _clusterConfig_payments_view.pricing;
    var ref = pricingPageConfig || {}, clusterPlans = ref.plans;
    var shouldUseHiddenPlans = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(clusterPlans) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_3__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
    if (!shouldUseHiddenPlans) return plans;
    var hiddenPlans = clusterPlans.hidden_plans, tmp = clusterPlans.plan_overrides, planOverrides = tmp === void 0 ? {} : tmp;
    var filteredPlans = plans.filter(function(plan) {
        return !hiddenPlans.includes(plan.tier);
    }).map(function(plan) {
        return (0,_pricing_page_clusterization_clusterized_pricing_page_helper_service__WEBPACK_IMPORTED_MODULE_5__/* .applyOverrides */ .RW)(plan, planOverrides[plan.tier], [
            "displayName"
        ]);
    });
    (0,_bigbrain_service__WEBPACK_IMPORTED_MODULE_4__.trackEvent)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED, {
        kind: "user_experience_for_cluster",
        info1: clusterId,
        info2: "payments_view[pricing]",
        data: hiddenPlans,
        placement: "hidden_plans"
    });
    return filteredPlans;
};
var getPreviousTierName = function(currentTier, plans) {
    var _plans_;
    var index = plans.findIndex(function(plan) {
        return plan.tier === currentTier;
    });
    return (_plans_ = plans[index - 1]) === null || _plans_ === void 0 ? void 0 : _plans_.displayName;
};
var getPreviousTierNameByTier = function(currentTier, tiers) {
    var _tiers_;
    var index = tiers.findIndex(function(tier) {
        return tier === currentTier;
    });
    return index > 0 ? (_tiers_ = tiers[index - 1]) === null || _tiers_ === void 0 ? void 0 : _tiers_.name : undefined;
};
var _obj1;
var TIER_TRANSLATION_KEY_BY_TIER = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, "pricingPage.plans.free.title.name_free"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, "pricingPage.plans.basic.title"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, "pricingPage.plans.standard.title"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, "pricingPage.plans.pro.title"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, "pricingPage.plans.enterprise.title"), _obj1);
var getTierTranslationKey = function(tierName) {
    var hasStudentPlan = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).hasStudentPlan;
    if (tierName === constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE && hasStudentPlan) {
        return "pricingPage.plans.student.title";
    }
    return TIER_TRANSLATION_KEY_BY_TIER[tierName];
};


/***/ }),

/***/ 4442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ getPricingContactUsLink; }
/* harmony export */ });
/* unused harmony export getDefaultContactUsPageLink */
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69017);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77784);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__);



var DEFAULT_CONTACT_SALES_LINK = "/sales/contact-us?from=pricing&source=Website%20-%20Contact%20Sales";
var ENTERPRISE_CONTACT_SALES_LINK = "/sales/contact-us/enterprise?from=pricing&source=Website%20-%20Contact%20Sales";
var getClusterContactUsLinksByTier = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var contactUsLinks = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.contact_us_links;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(contactUsLinks) && (0,_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return contactUsLinks;
    }
    return {};
};
var getPricingContactUsLink = function(tier, clusterConfig, abTests, cookies, forcePricing) {
    var contactUsLinksByTier = getClusterContactUsLinksByTier(clusterConfig, abTests, cookies, forcePricing);
    var contactUsLink = contactUsLinksByTier[tier];
    return contactUsLink || getDefaultContactUsPageLink(abTests);
};
var getDefaultContactUsPageLink = function(abTests) {
    var sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if ((0,services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__.shouldGetEnterpriseContactUsPageAbTest)(abTests, sendBigBrainEvent)) return ENTERPRISE_CONTACT_SALES_LINK;
    return DEFAULT_CONTACT_SALES_LINK;
};


/***/ }),

/***/ 60004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getPricingDimensions; }
/* harmony export */ });
var PRICING_DIMENSIONS_2_PLANS = {
    tierCards: {
        planWidth: 40
    },
    featuresSection: {
        featureWidth: 40,
        planWidth: 30
    }
};
var PRICING_DIMENSIONS_3_PLANS = {
    tierCards: {
        planWidth: 30
    },
    featuresSection: {
        featureWidth: 28,
        planWidth: 24
    }
};
var PRICING_DIMENSIONS_4_PLANS = {
    tierCards: {
        planWidth: 24
    },
    featuresSection: {
        featureWidth: 24,
        planWidth: 19
    }
};
var PRICING_DIMENSIONS_5_PLANS = {
    tierCards: {
        planWidth: 19,
        topInfoSize: "sm"
    },
    featuresSection: {
        featureWidth: 20,
        planWidth: 16
    }
};
var getPricingDimensions = function(plans) {
    // calculates the size (percentage) of each plan cell in the pricing page, and the feature cell on the left, and returns it.
    // calculation explanation: the desired result is one where (number of plans)*(plan_width) + feature_width = 100.
    switch(plans.length){
        case 2:
            {
                return PRICING_DIMENSIONS_2_PLANS;
            }
        case 3:
            {
                return PRICING_DIMENSIONS_3_PLANS;
            }
        case 4:
            {
                return PRICING_DIMENSIONS_4_PLANS;
            }
        default:
            {
                // 5 tiers
                return PRICING_DIMENSIONS_5_PLANS;
            }
    }
};


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

}]);